// Module
var code = "<div class=\"ui-grid-cell-contents\">\n    <usage-caps-indicator usage-caps-array=\"row.entity.UsageCapElections.usageCaps\" business-unit-currency-code=\"row.entity.UsageCapElections.currencyCode\" always-visible=\"true\">\n    </usage-caps-indicator>\n</div>\n";
// Exports
module.exports = code;